// extracted by mini-css-extract-plugin
module.exports = {"container":"CounterpartyContent_container__wVclF","spin":"CounterpartyContent_spin__cHzzV"};